module.exports = __webpack_public_path__ + "static/media/linkedin.9c5a10ea.svg";